const StatsCards = ({ stats, isCactusAdmin }) => {
    return (
        <div className="stats-container">
            <div className="stat-card">
                <div className="stat-card-value text-[#2b364b]">{stats.total}</div>
                <div className="stat-card-label">Total Requests</div>
            </div>

            {isCactusAdmin ? (
                <>
                    <div className="stat-card">
                        <div className="stat-card-value text-amber-500">{stats.received}</div>
                        <div className="stat-card-label">Received</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-card-value text-blue-500">{stats.processing}</div>
                        <div className="stat-card-label">Processing</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-card-value text-emerald-500">{stats.completed}</div>
                        <div className="stat-card-label">Shipped</div>
                    </div>
                </>
            ) : (
                <>
                    <div className="stat-card">
                        <div className="stat-card-value text-amber-500">{stats.pending}</div>
                        <div className="stat-card-label">Requested</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-card-value text-emerald-500">{stats.approved}</div>
                        <div className="stat-card-label">Approved</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-card-value text-blue-500">{stats.inProduction}</div>
                        <div className="stat-card-label">In Production</div>
                    </div>
                </>
            )}
        </div>
    )
}

export default StatsCards
